const QuotationProductsModal = ({ record, onClose }) => {
  if (!record) return null;

  const items = Array.isArray(record.items) ? record.items : [];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={(event) => event.target === event.currentTarget && onClose()}
    >
      <div className="w-full max-w-2xl rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
          <div>
            <h2 className="text-base font-semibold text-gray-900">
              Quotation Products
            </h2>
            <p className="mt-0.5 text-xs text-gray-400">
              {record.companyName} · Quotation No {record.quotationNo}
            </p>
          </div>
          <button
            onClick={onClose}
            className="rounded-lg p-1.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <svg
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="max-h-[60vh] overflow-y-auto px-5 py-4">
          {items.length === 0 ? (
            <p className="text-sm text-gray-400">No products listed.</p>
          ) : (
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs uppercase tracking-wide text-gray-400">
                  <th className="pb-2 pr-2 font-medium">#</th>
                  <th className="pb-2 pr-2 font-medium">Product</th>
                  <th className="pb-2 pr-2 text-center font-medium">Qty</th>
                  <th className="pb-2 pr-2 text-right font-medium">Rate</th>
                  <th className="pb-2 pr-2 text-center font-medium">Unit</th>
                  <th className="pb-2 text-right font-medium">Amount</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr
                    key={item._id ?? index}
                    className="border-t border-gray-100 align-top"
                  >
                    <td className="py-2.5 pr-2 text-gray-500">{index + 1}</td>
                    <td className="py-2.5 pr-2 text-gray-800 break-words">
                      {item.description}
                    </td>
                    <td className="py-2.5 pr-2 text-center text-gray-700">
                      {item.qty}
                    </td>
                    <td className="py-2.5 pr-2 text-right text-gray-700">
                      {Number(item.rate || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="py-2.5 pr-2 text-center text-gray-700">
                      {item.unit}
                    </td>
                    <td className="py-2.5 text-right font-medium text-gray-900">
                      {Number(item.amount || 0).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="border-t-2 border-gray-200">
                  <td colSpan={5} className="py-2.5 pr-2 text-right text-xs font-semibold uppercase tracking-wide text-gray-500">
                    Total
                  </td>
                  <td className="py-2.5 text-right font-semibold text-gray-900">
                    {Number(record.totalAmount || 0).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </div>

        <div className="border-t border-gray-100 px-5 py-4">
          <button
            onClick={onClose}
            className="w-full rounded-lg border border-gray-200 py-2 text-sm text-gray-600 hover:bg-gray-50"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuotationProductsModal;